import { render, staticRenderFns } from "./HumanCapitalBase.vue?vue&type=template&id=66018a1e&"
import script from "./HumanCapitalBase.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports